import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

export async function getJsonTableColumn(reportId) {
	var columnsArr = [];
	firebase
		.database()
		.ref('/kavtek_report_information/' + PROJECT_CODE.projectCode)
		.orderByChild('id')
		.equalTo(reportId)
		.once('value', (snapshot) => {
			var reportObj = snapshot.val();
			var reportObjKey = Object.keys(reportObj);
			var reportDetails = reportObj[reportObjKey[0]];
			var columns = reportDetails['columns'];

			var columnKeys = Object.keys(columns);

			columnKeys.forEach((column) => {
				var item = columns[column];
				columnsArr.push(item);
			});
		});

	return columnsArr;
}
